export class CrossResourceQueryRequestResourcesInner {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "alias",
            "baseName": "alias",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceId",
            "baseName": "resourceId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "snapshotId",
            "baseName": "snapshotId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "databaseName",
            "baseName": "databaseName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CrossResourceQueryRequestResourcesInner.attributeTypeMap;
    }
    constructor() {
    }
}
